import React from 'react'

function ReturnsFromSiteReport() {
  return (
    <div>ReturnsFromSiteReport</div>
  )
}

export default ReturnsFromSiteReport